import { render, staticRenderFns } from "./MissingForm.vue?vue&type=template&id=4297723c&scoped=true&"
import script from "./MissingForm.vue?vue&type=script&lang=js&"
export * from "./MissingForm.vue?vue&type=script&lang=js&"
import style0 from "./MissingForm.vue?vue&type=style&index=0&id=4297723c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297723c",
  null
  
)

export default component.exports